<div class="side-nav" [class.side-nav--collapsed]="!isExpanded">
  <div *ngIf="showTrialBanner" class="side-nav__trial">
    <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>
    <p>
      <strong>{{ 'sideMenu.trialPlanTitle' | translate }}</strong>
      <span *ngIf="isExpanded"> — {{ 'sideMenu.trialDaysRemaining' | translate: { count: trialDaysRemaining } }}</span>
    </p>
  </div>

  <div class="side-nav__header">
    <button type="button" class="side-nav__toggle" (click)="toggleMenu()" [attr.aria-expanded]="isExpanded" [title]="'sideMenu.menuLabel' | translate">
      <span class="nav-ic" [style.--nav-ic]="'url(/assets/image/nav/grid.svg)'" aria-hidden="true"></span>
      <span *ngIf="isExpanded" class="side-nav__toggle-label">{{ 'sideMenu.menuLabel' | translate }}</span>
    </button>
  </div>

  <div class="side-nav__search" *ngIf="isExpanded">
    <span class="nav-ic side-nav__search-ic" [style.--nav-ic]="'url(/assets/image/nav/search.svg)'"></span>
    <input
      type="search"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchInput()"
      (focus)="showSearchResults = true"
      (blur)="onSearchBlur()"
      [placeholder]="'sideMenu.searchPlaceholder' | translate"
      autocomplete="off"
    />
  </div>

  <nav class="side-nav__scroll" aria-label="Application">
    <ul class="side-nav__list">
      <li *ngFor="let item of filteredMenu" class="side-nav__group" [class.is-open]="isSubMenuOpen(item.title)" [hidden]="!menuVisible(item)">
        <button
          *ngIf="item.haveSubMenu; else directLink"
          type="button"
          class="side-nav__parent"
          [class.is-active]="isSectionActive(item)"
          [title]="item.title"
          (click)="onClick(true, item.title)"
        >
          <span class="nav-ic" [style.--nav-ic]="'url(' + item.image + ')'"></span>
          <span *ngIf="isExpanded" class="side-nav__label">{{ item.name | translate }}</span>
          <svg *ngIf="isExpanded" class="side-nav__chevron" [class.is-open]="isSubMenuOpen(item.title)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 5l7 7-7 7" />
          </svg>
        </button>

        <ng-template #directLink>
          <a
            class="side-nav__parent"
            [class.is-active]="isSubActive(item)"
            [routerLink]="'/home/' + item.route"
            [title]="item.title"
            (click)="onDirectLinkClick($event, item)"
          >
            <span class="nav-ic" [style.--nav-ic]="'url(' + item.image + ')'"></span>
            <span *ngIf="isExpanded" class="side-nav__label">{{ item.name | translate }}</span>
          </a>
        </ng-template>

        <ul *ngIf="item.haveSubMenu && isExpanded && isSubMenuOpen(item.title)" class="side-nav__sub">
          <li *ngFor="let sub of visibleChildren(item)">
            <button
              *ngIf="sub.action === 'logout'"
              type="button"
              class="side-nav__child side-nav__child--danger"
              (click)="onClick(false, 'Log out')"
            >
              <span class="nav-ic" [style.--nav-ic]="'url(' + sub.image + ')'"></span>
              <span class="side-nav__label">{{ sub.name | translate }}</span>
            </button>
            <a
              *ngIf="sub.action !== 'logout'"
              class="side-nav__child"
              [class.is-active]="isSubActive(sub)"
              [routerLink]="'/home/' + sub.route"
              [queryParams]="sub.queryParams || null"
              (click)="onSubmenuClick($event, sub)"
            >
              <span class="nav-ic" [style.--nav-ic]="'url(' + sub.image + ')'"></span>
              <span class="side-nav__label">{{ sub.name | translate }}</span>
              <span *ngIf="sub.count !== undefined && sub.count !== null" class="side-nav__count">{{ sub.count }}</span>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>
